import { logError, logWarning, log as _log } from '_utils/logs';

export const log = _log;
export const warn = logWarning;
export const error = logError;
